<script setup lang="ts">
defineOptions({
	name: 'DataProtectionSection',
})

const { t: $t, locale } = useI18n()
const { $tThird } = useNuxtApp()

const firstHtml = computed(() => {
	return $tThird(
		'Our Privacy Policy describes how we collect, use, store and disclose {users_more} Personal Data, and is hereby incorporated into these {terms_conditions}. {users} agree to the collection, use, storage, and disclosure of your data under our Privacy Policy. Processing of personal data shall always be carried out in accordance with Regulation (EU) 2016/679 (General Data Protection Regulation – GDPR) and applicable Portuguese data protection laws.',
		{
			users:
				locale.value === 'fr'
					? `<span class="font-semibold">${$t('the User')}  </span>`
					: `<span class="font-semibold capitalize">${$t('Users')}</span>`,
			terms_conditions: `<span class="font-semibold">${$t('Terms & Conditions')}</span>`,
			users_more: `<span class="font-semibold">${$t('Users’')}</span>`,
		},
	)
})
</script>

<template>
	<section class="space-y-7">
		<div class="flex items-center gap-3.5">
			<UIcon
				name="i-carbon:manage-protection"
				class="size-7 text-[#ED8B00]"
			/>
			<h2 class="text-xl sm:text-2xl font-medium text-gray-900 tracking-tight">
				{{ $t('Data Protection') }}
			</h2>
		</div>
		<div class="space-y-5 text-base sm:text-[18px] text-[#364153] tracking-[-0.199px] leading-7">
			<p v-html="firstHtml"></p>
		</div>
	</section>
</template>
